import { useFlutter } from '@/composables/useFlutter';

export const FlutterVuexPlugin = store => {
  store.$logToFlutter = useFlutter(store).logToFlutter;
};
